import { camelCase, CamelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import useSWR from "swr"
import { useSmoothApi } from "./useSmoothApi"

export type VirtualAccount = CamelCase<{
  bank_name: string
  branch_name: string
  account_number: string
  account_holder_name: string
}>

export type User = CamelCase<{
  id: number
  status: number
  first_name: string
  last_name: string
  first_furigana: string
  last_furigana: string
  line_user_name: string
  address: string
  icon_src: string
  gender: "男性" | "女性"
  birthday: string
  enabled: true
  created_at: string
  updated_at: string
  tracking_id: string
  line_profile_synced_at: string
  is_no_bypass: boolean
  virtual_account: VirtualAccount
  full_name_alphabet: string
}>

export const useUserSWR = (userId: number) => {
  const { getWithToken } = useSmoothApi()

  const url = userId > 0 ? SMOOTH_SMOOTHER_API_URL + "/users/" + userId : null

  const userSWR = useSWR<User>(url, async (url: string) => {
    const res = await getWithToken(url)
    const data = camelCase(res.data)["data"] as User
    return data
  })

  return { ...userSWR, url }
}
